/* eslint-disable react/display-name */
import React from 'react';
import { useLocation } from 'react-router-dom';

export const withLocation = (Component) => (props) => <Component {...props} location={useLocation()} />;
